import { httpRequest } from "../../http";
import { CatalogCoreFieldSample, CoreFieldSampleIn } from "@models/catalog.model";

const COLL = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/core-field-samples/`;

export class CommandCreateCoreFieldSample {
  async run(payload: CoreFieldSampleIn): Promise<CatalogCoreFieldSample> {
    return httpRequest<CatalogCoreFieldSample>(COLL, { method: "POST", body: payload });
  }
}

export class CommandUpdateCoreFieldSample {
  async run(id: number, payload: CoreFieldSampleIn): Promise<CatalogCoreFieldSample> {
    return httpRequest<CatalogCoreFieldSample>(`${COLL}${id}/`, { method: "PUT", body: payload });
  }
}

export class CommandDeleteCoreFieldSample {
  async run(id: number): Promise<void> {
    await httpRequest(`${COLL}${id}/`, { method: "DELETE" });
  }
}
